import { BrainCircuit, Sparkles, LayoutDashboard } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function WelcomeStep() {
  const { t } = useTranslation();

  const CARDS = [
    {
      icon: BrainCircuit,
      iconColor: 'text-violet-400',
      title: t('onboarding.pillar_visual_brain'),
      description: t('onboarding.pillar_visual_brain_desc'),
      borderColor: '#2e1a47',
    },
    {
      icon: Sparkles,
      iconColor: 'text-amber-400',
      title: t('onboarding.pillar_synapse'),
      description: t('onboarding.pillar_synapse_desc'),
      borderColor: '#3d2a14',
    },
    {
      icon: LayoutDashboard,
      iconColor: 'text-emerald-400',
      title: t('onboarding.pillar_entities'),
      description: t('onboarding.pillar_entities_desc'),
      borderColor: '#1a3329',
    },
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold text-zinc-100">{t('onboarding.welcome_title')}</h2>
      <p className="text-sm text-zinc-400 mt-2 max-w-lg">{t('onboarding.welcome_description')}</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
        {CARDS.map((card, i) => (
          <div
            key={card.title}
            className="bg-zinc-800/60 border rounded-xl p-5 hover:border-violet-500/30 transition-colors"
            style={{
              borderColor: card.borderColor,
              animation: 'onboarding-card-in 400ms ease-out both',
              animationDelay: `${i * 100}ms`,
            }}
          >
            <card.icon className={`w-8 h-8 ${card.iconColor}`} />
            <h3 className="text-sm font-semibold text-zinc-100 mt-3">{card.title}</h3>
            <p className="text-xs text-zinc-400 mt-1">{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
